import React, { lazy } from 'react';

const DistListWrapper = lazy( () => import( './dist-list-wrapper' ) );
const DistFormWrapper = lazy( () => import( './dist-form-wrapper' ) );

// Wrapper function for the component that gets rendered, is passed additional props from the outer arrow function?
const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

export const routes = [
    {
        title: 'Reward Distiribution Hatch List',
        pattern: '/:companyId?',
        render: ( props ) => <DistListWrapper { ...props } />,
    },
    {
        title: 'Reward Distiribution Hatch Form',
        pattern: '/:companyId?/program/:programId/detail/:distId?',
        render: ( props ) => <DistFormWrapper { ...props } />,
    },
];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    // destructuring match property out of next route
    const { match } = nextRoute;
    // if match exists, nothing has been rendered yet, and if the component isn't undefined
    if ( match && !match.render && typeof match.component !== 'undefined' ) {
        // we set the render property to the result of our bundle function. We pass it the component we want rendered, and it's corresponding props
        match.render = Bundle( match.component, match.props );
        action.ok();
    } else {
        action.ok();
    }
}
